<template>
  <ButtonLink
    :aria-label="title"
    v-bind="$props"
    data-test="link"
    class="l-IconButtonLink">
    <FontIcon
      data-test="icon"
      :class="{'mr-sm': hasSlotContent}"
      :name="icon"
    />
    <slot />
  </ButtonLink>
</template>

<script>
import { propDefinitions } from '@/components/library/links/definitions';
import ButtonLink from '@/components/library/links/ButtonLink.vue';
import FontIcon from '@/components/Icon.vue';

export default {
  name: 'IconButtonLink',
  components: {
    ButtonLink,
    FontIcon,
  },
  props: {
    /**
     * Since we bind the `$props` to the directly-wrapped `ButtonLink`
     * component, the same props for ButtonLink applies to this component.
     *
     * For convenience and to avoid code-repetition, the props have been
     * shared in the `./definitions.js` file. This approach should only be used
     * in edge-cases
     */
    ...propDefinitions,
    icon: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: false,
    },
  },
  computed: {
    hasSlotContent() {
      return !!this.$slots.default;
    },
    title() {
      return !this.hasSlotContent ? this.label : null;
    },
  },
};
</script>
